export const routes = {
  loginRoute: "/",
};

export const API_URL = "https://api.aimga.ashishrathi.com";
export const LOGIN_URL = `${API_URL}/profiles/login/`;
export const GET_ALL_GROUPS_URL = `${API_URL}/groups/`;
export const GET_USER_GROUPS_URL = `${API_URL}/profiles/me/groups`;
